var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{staticClass:"analytics-benchmark",attrs:{"title":"Benchmark","icon":"chart-line"},scopedSlots:_vm._u([{key:"custom-content",fn:function(){return [_c('b-col',[_c(_setup.AnalyticsNav),_c(_setup.SectorBenchmarkMetrics),_c(_setup.BenchmarkMetrics)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }